// ============================================
// PWA SERVICE WORKER REGISTRATION
// Install UI has moved to InstallAppButton.js. This component now only
// handles the service worker lifecycle (register, update detection).
// Kept as a component (not a plain hook) so existing App.js imports still work.
// ============================================

import { useEffect } from 'react';

const PWAInstallPrompt = () => {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const register = () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          // Listen for updates — auto-apply new versions
          reg.addEventListener('updatefound', () => {
            const sw = reg.installing;
            if (!sw) return;
            sw.addEventListener('statechange', () => {
              if (sw.state === 'installed' && navigator.serviceWorker.controller) {
                // New version is waiting — tell it to take over immediately
                sw.postMessage('SKIP_WAITING');
              }
            });
          });
        })
        .catch((err) => {
          console.warn('[PWA] SW registration failed:', err);
        });
    };

    // Wait for window load to avoid competing with critical-path resources
    if (document.readyState === 'complete') {
      register();
    } else {
      window.addEventListener('load', register, { once: true });
    }
  }, []);

  return null;
};

export default PWAInstallPrompt;
